import { graphql } from "~/gql";
import { EXTERNAL_MATTER_FRAGMENT } from "../fragment/external-matter-fragment";

export const FIND_ALL_EXTERNAL_MATTERS = graphql(/* GraphQL */ `
  query findAllExternalMatters {
    findAllExternalMatters {
      ...ExternalMatterParts
    }
  }
  ${EXTERNAL_MATTER_FRAGMENT}
`);
